/* eslint-disable react/prop-types */
import { Tag as AntdTag } from 'antd';
import cn from 'clsx';
import React from 'react';
import classes from './Tag.module.scss';

const ATag = ({ className = '', ...other }) => {
  return <AntdTag {...other} className={cn(classes.wrapper, className)} />;
};

export default ATag;
